import React from 'react'
import AboutDevelopment_1 from '../1'
import { RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const DevelopmentAmenitiesTop3 = ({ developmentID, ...props }: CombinedProps) => {

  console.log(developmentID)
  return (
    <AboutDevelopment_1
      {...props}
      developmentID={developmentID}
      hidden={true}
    />
  )
}

export default DevelopmentAmenitiesTop3
